<template>
  <div>
    <vs-table
      id="transactionTable"
      ref="transactionTable"
      stripe
      class="vs-con-loading__container"
      single
      pagination
      :max-items="itemsPerPage"
      search
      :data="transactions"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
        <div class="pl-3 pb-3 mr-4 flex items-center justify-between font-medium text-base">
          <h3 class="ml-2">Transactions</h3>
        </div>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ transactions.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : transactions.length }} of {{ transactions.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-button v-show="transactions.length > 0" class="mb-3 ml-3" type="border" color="success" icon-pack="feather" icon="icon-download" @click="exportTransactionsToExcel">Download .csv</vs-button>
      </div>

      <template slot="thead">
        <vs-th sort-key="transactionType">Reason</vs-th>
        <vs-th sort-key="amount">Amount</vs-th>
        <vs-th sort-key="createdOn">Date</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="item" :state="item.amount < 0 ? 'danger' : 'success'" :key="indextr" v-for="(item, indextr) in data">
          <vs-td :data="data[indextr].transactionType">{{ item.transactionType }}</vs-td>

          <vs-td :data="data[indextr].amount" :style="{ color: item.amount < 0 ? 'rgb(255, 0, 0)' : item.amount > 0 ? 'rgb(0, 128, 0)' : ''}">{{ "R " + Number(item.amount).toLocaleString('en') }}</vs-td>

          <vs-td :data="data[indextr].createdOn">{{ item.createdOn.replace("T", " ").split('.')[0] }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerTitleTrans: ["Reason","Amount","Date"],
      headerValTrans: ["transactionType","amount","createdOn"],
      itemsPerPage: 6,
      isMounted: false,
      loadingColor: "#fff",
      transactions: [],
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.transactionTable.currentx;
      }
      return 0;
    }
  },
  methods: {
    loadTransactionInfo() {
      const self = this;
      self.showLoadingOnElement("transactionTable", 1, "corners");

      var onSuccess = function(response) {
        self.transactions = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.transactionTable.$el);
      };

      self.$ajaxGet(self, "Student/ListTransactions", onSuccess, onFinally);
    },
    exportTransactionsToExcel() {
      var self = this;
      import('@/vendor/Export2Excel').then(excel => {
        const list = self.transactions;
        const data = self.formatJson(self.headerValTrans, list);
        var date = new Date();
        excel.export_json_to_excel({
          header: self.headerTitleTrans,
          data,
          filename: `Transactions (${date.getDate()}-${date.getMonth()}-${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()})`,
          autoWidth: false,
          bookType: "csv"
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
    scrollToFooter() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -480,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("footerGlobal"),
        100,
        scrollOptions
      );
    }
  },
  mounted() {
    var self = this;
    self.loadTransactionInfo();
    self.isMounted = true;
  }
};
</script>

<style lang="scss">
#top-right-close {
  right: 0;
  position: absolute;
  top: 0;
  margin-right: 3px;
  margin-top: 3px;
}

#milestones-row {
  align-items: flex-end;
}

#delete-column {
  text-align: -webkit-center;
  text-align: -moz-center;
}

.numberinput {
  background: #ffffff;
  float: left;
}

#optionText_TextArea {
  width: 50%;
}

#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
